import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoPlano } from "../../../../types";
import BlocoAlteracoes from "../../Compartilhado/Blocos/BlocoAlteracoes";
import { CampoAlteracao } from "../../Compartilhado/Blocos/BlocoAlteracoes";
import { formatServicoColuna } from "../../../../../../../utils/servicoMapperPlanos";

interface ExpandedContentProps {
  item: IItemHistoricoPlano;
  isExpanded?: boolean;
}

function formatarValor(valor: any, isMonetary: boolean = false): string {
  if (valor === null || valor === undefined) return '—';

  let valorNumerico: number;
  if (typeof valor === 'string') {
    valorNumerico = parseFloat(valor);
    if (isNaN(valorNumerico)) return String(valor);
  } else if (typeof valor === 'number') {
    valorNumerico = valor;
  } else {
    return String(valor);
  }

  if (isMonetary) {
    const valorFormatado = valorNumerico.toFixed(2).replace('.', ',');
    const partes = valorFormatado.split(',');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${partes.join(',')}`;
  }

  return String(valorNumerico);
}

/** Gera campos de um único serviço sem prefixo no nome (Modo de Precificação, Créditos, etc.). */
function camposDeUmServico(itemAntes: any, itemDepois: any): CampoAlteracao[] {
  const campos: CampoAlteracao[] = [];

  if (!itemAntes && itemDepois) {
    if (itemDepois.modo_precificacao !== 'sob_consulta') {
      campos.push({ campo: 'Créditos', antes: '—', depois: formatarValor(itemDepois.creditos_padrao, false) });
      campos.push({ campo: 'Valor/Crédito', antes: '—', depois: formatarValor(itemDepois.valor_credito, true) });
      if (itemDepois.creditos_padrao != null && itemDepois.valor_credito != null) {
        campos.push({
          campo: 'Valor Total',
          antes: '—',
          depois: formatarValor(Number(itemDepois.creditos_padrao) * Number(itemDepois.valor_credito), true)
        });
      }
    } else {
      campos.push({ campo: 'Modo de Precificação', antes: '—', depois: 'Sob Consulta' });
    }
    return campos;
  }

  if (itemAntes && !itemDepois) {
    if (itemAntes.modo_precificacao !== 'sob_consulta') {
      campos.push({ campo: 'Créditos', antes: formatarValor(itemAntes.creditos_padrao, false), depois: '—' });
      campos.push({ campo: 'Valor/Crédito', antes: formatarValor(itemAntes.valor_credito, true), depois: '—' });
      if (itemAntes.creditos_padrao != null && itemAntes.valor_credito != null) {
        campos.push({
          campo: 'Valor Total',
          antes: formatarValor(Number(itemAntes.creditos_padrao) * Number(itemAntes.valor_credito), true),
          depois: '—'
        });
      }
    } else {
      campos.push({ campo: 'Modo de Precificação', antes: 'Sob Consulta', depois: '—' });
    }
    return campos;
  }

  if (!itemAntes || !itemDepois) return campos;

  const mudouParaSobConsulta = itemAntes.modo_precificacao !== 'sob_consulta' && itemDepois.modo_precificacao === 'sob_consulta';
  const mudouDeSobConsulta = itemAntes.modo_precificacao === 'sob_consulta' && itemDepois.modo_precificacao !== 'sob_consulta';

  if (itemAntes.modo_precificacao !== itemDepois.modo_precificacao) {
    campos.push({
      campo: 'Modo de Precificação',
      antes: itemAntes.modo_precificacao === 'sob_consulta' ? 'Sob Consulta' : 'Fixo em Créditos',
      depois: itemDepois.modo_precificacao === 'sob_consulta' ? 'Sob Consulta' : 'Fixo em Créditos'
    });
    if (mudouParaSobConsulta) {
      campos.push({ campo: 'Créditos', antes: formatarValor(itemAntes.creditos_padrao, false), depois: '—' });
      campos.push({ campo: 'Valor/Crédito', antes: formatarValor(itemAntes.valor_credito, true), depois: '—' });
      if (itemAntes.creditos_padrao != null && itemAntes.valor_credito != null) {
        campos.push({
          campo: 'Valor Total',
          antes: formatarValor(Number(itemAntes.creditos_padrao) * Number(itemAntes.valor_credito), true),
          depois: '—'
        });
      }
      if (itemAntes.modalidade) {
        campos.push({ campo: 'Modalidade', antes: formatarValor(itemAntes.modalidade), depois: '—' });
      }
      if (itemAntes.profissional) {
        campos.push({ campo: 'Profissional', antes: formatarValor(itemAntes.profissional), depois: '—' });
      }
    }
    if (mudouDeSobConsulta) {
      campos.push({ campo: 'Créditos', antes: '—', depois: formatarValor(itemDepois.creditos_padrao, false) });
      campos.push({ campo: 'Valor/Crédito', antes: '—', depois: formatarValor(itemDepois.valor_credito, true) });
      if (itemDepois.creditos_padrao != null && itemDepois.valor_credito != null) {
        campos.push({
          campo: 'Valor Total',
          antes: '—',
          depois: formatarValor(Number(itemDepois.creditos_padrao) * Number(itemDepois.valor_credito), true)
        });
      }
      if (itemDepois.modalidade) {
        campos.push({ campo: 'Modalidade', antes: '—', depois: formatarValor(itemDepois.modalidade) });
      }
      if (itemDepois.profissional) {
        campos.push({ campo: 'Profissional', antes: '—', depois: formatarValor(itemDepois.profissional) });
      }
    }
  }

  if (!mudouParaSobConsulta && !mudouDeSobConsulta && itemDepois.modo_precificacao !== 'sob_consulta') {
    if (itemAntes.creditos_padrao !== itemDepois.creditos_padrao) {
      campos.push({
        campo: 'Créditos',
        antes: formatarValor(itemAntes.creditos_padrao, false),
        depois: formatarValor(itemDepois.creditos_padrao, false)
      });
    }
    if (itemAntes.valor_credito !== itemDepois.valor_credito) {
      campos.push({
        campo: 'Valor/Crédito',
        antes: formatarValor(itemAntes.valor_credito, true),
        depois: formatarValor(itemDepois.valor_credito, true)
      });
    }
    const valorTotalAntes = itemAntes.creditos_padrao != null && itemAntes.valor_credito != null
      ? Number(itemAntes.creditos_padrao) * Number(itemAntes.valor_credito) : null;
    const valorTotalDepois = itemDepois.creditos_padrao != null && itemDepois.valor_credito != null
      ? Number(itemDepois.creditos_padrao) * Number(itemDepois.valor_credito) : null;
    if (valorTotalAntes !== valorTotalDepois && (valorTotalAntes != null || valorTotalDepois != null)) {
      campos.push({
        campo: 'Valor Total',
        antes: formatarValor(valorTotalAntes, true),
        depois: formatarValor(valorTotalDepois, true)
      });
    }
  }

  return campos;
}

function mapearDadosPrecificacaoEditada(payload: any): CampoAlteracao[] {
  if (!payload || !payload.antes || !payload.depois) return [];

  const antes = Array.isArray(payload.antes) ? payload.antes : [];
  const depois = Array.isArray(payload.depois) ? payload.depois : [];
  const antesMap = new Map(antes.map((item: any) => [item.id_plano_servico_template, item]));
  const depoisMap = new Map(depois.map((item: any) => [item.id_plano_servico_template, item]));
  const todosIds = new Set([...Array.from(antesMap.keys()), ...Array.from(depoisMap.keys())]);
  const campos: CampoAlteracao[] = [];

  todosIds.forEach((id) => {
    const itemAntes = antesMap.get(id) as any;
    const itemDepois = depoisMap.get(id) as any;
    const servico = (itemDepois || itemAntes)?.servico || (itemDepois || itemAntes)?.area_direito || 'Serviço';
    camposDeUmServico(itemAntes, itemDepois).forEach((c) => {
      campos.push({ ...c, campo: `${servico} - ${c.campo}` });
    });
  });

  return campos;
}

export default function ExpandedContentPrecificacaoEditada({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload) : item.payload;

  // Novo formato: um log com payload.servicos (uma box por serviço)
  if (payload?.servicos && Array.isArray(payload.servicos) && payload.servicos.length > 0) {
    return (
      <ExpandedContent>
        <Separator />
        <h4 className="section-title">PRECIFICAÇÃO DE SERVIÇOS</h4>
        {payload.servicos.map((s: any, idx: number) => {
          const antes = s.antes ?? null;
          const depois = s.depois ?? null;
          const nomeServico = formatServicoColuna(
            depois?.area_direito ?? antes?.area_direito,
            depois?.servico ?? antes?.servico,
            depois?.tipo_audiencia ?? antes?.tipo_audiencia
          );
          const campos = camposDeUmServico(antes, depois);
          if (campos.length === 0) return null;
          return (
            <BlocoAlteracoes
              key={s.id_plano_servico_template ?? idx}
              campos={campos}
              sectionTitle={nomeServico}
              tituloComoFaixa
            />
          );
        })}
      </ExpandedContent>
    );
  }

  // Formato antigo: payload.antes / payload.depois (compatibilidade)
  const campos = mapearDadosPrecificacaoEditada(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhuma alteração detectada.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoAlteracoes campos={campos} sectionTitle="PRECIFICAÇÃO DE SERVIÇOS" />
    </ExpandedContent>
  );
}
